import {
  BoardCardButton, BoardCardButtonWrapper,
  BoardCardContainer,
  BoardCardIconContainer, BoardCardsDeleteMod, BoardCardsDeleteModButtons, BoardCardsDeleteModContent,
  BoardCardStatus,
  BoardCardSubTitle,
  BoardCardTitle
} from "./BoardCard.styled";
import {compactFileName, formatFileSize} from "../../../page/dashboard/includes";
import {FileIcon} from "../../../assets/svg/fileIcon";
import {ProcessingIcon} from "../../../assets/svg/processingIcon";
import {ErrorIcon} from "../../../assets/svg/errorIcon";
import {DownloadIcon} from "../../../assets/svg/downloadIcon";
import {HashIcon} from "../../../assets/svg/hashIcon";
import {DeleteIcon} from "../../../assets/svg/deleteIcon";
import {useState} from "react";
import {Button, Typography} from "@mui/material";

interface BoardCardProps {
  status: string
  title: string
  subtitle: number
  hash: string
  active: boolean

  downloadFile: () => void
  deleteFile: () => void
}

export function BoardCard({status, title, subtitle, hash, active, downloadFile, deleteFile}: BoardCardProps) {
  const [deleteMod, setDeleteMod] = useState<boolean>(false);

  return (
    <>
      {deleteMod ?
        <BoardCardsDeleteMod>
          <BoardCardsDeleteModContent>
            <Typography fontSize="16px" p="8px">Delete this file?</Typography>
            <BoardCardsDeleteModButtons>
              <Button variant={'outlined'} onClick={() => setDeleteMod(false)}>Cancel</Button>
              <Button variant={'outlined'} onClick={deleteFile}>Delete</Button>
            </BoardCardsDeleteModButtons>
          </BoardCardsDeleteModContent>
        </BoardCardsDeleteMod> :
        <BoardCardContainer active={active}>
            {active ?
              <BoardCardButtonWrapper>
                {status === 'success' && <>
                    <BoardCardButton variant={'outlined'} startIcon={<DownloadIcon/>} onClick={downloadFile}>Download</BoardCardButton>
                    <BoardCardButton variant={'outlined'} startIcon={<HashIcon/>} onClick={() => window.open(`https://whatsonchain.com/tx/${hash}`, '_blank', 'noopener,noreferrer')}>Script Hash</BoardCardButton>
                </>}
                <BoardCardButton variant={'outlined'} startIcon={<DeleteIcon/>} onClick={() => setDeleteMod(true)}>Delete</BoardCardButton>
              </BoardCardButtonWrapper>
              :
              <>
                <BoardCardIconContainer>
                  <FileIcon/>
                  <BoardCardStatus>
                    {status === 'processing' && <ProcessingIcon/>}
                    {status === 'error' && <ErrorIcon/>}
                  </BoardCardStatus>
                </BoardCardIconContainer>
                <BoardCardTitle>{compactFileName(title)}</BoardCardTitle>
                <BoardCardSubTitle>{formatFileSize(subtitle)}</BoardCardSubTitle>
              </>
            }
        </BoardCardContainer>
      }
    </>
  )
}